/* KUP Coffees — carousel dots.

   One dot per product is wrong at the end of the rail: once the scroller hits
   its maximum, the final cards can never reach the left edge, so their dots
   are unclickable dead weight. This builds a dot only for each scroll position
   that is actually reachable, and the last dot covers whatever tail of cards
   shares that final position. Positions are recalculated on resize, because
   how many cards fit — and therefore how many are reachable — changes with
   viewport width. */
(function(){
  'use strict';

  function init(rail){
    if(!rail || rail.dataset.kupDotsBound === '1') return;
    rail.dataset.kupDotsBound = '1';

    var wrap = rail.closest('section');
    if(!wrap) return;
    var dotWrap = wrap.querySelector('[data-kup-dots]');
    var ctrl    = wrap.querySelector('[data-kup-ctrl]');
    var prev    = wrap.querySelector('[data-kup-prev]');
    var next    = wrap.querySelector('[data-kup-next]');
    var cards   = [].slice.call(rail.querySelectorAll('.kup-card'));
    if(!cards.length){ if(ctrl) ctrl.style.display='none'; return; }

    var stops = [], dots = [], active = -1, ticking = false;

    function gap(){
      var cs = getComputedStyle(rail);
      return parseFloat(cs.columnGap || cs.gap) || 20;
    }

    function build(){
      var max = rail.scrollWidth - rail.clientWidth;
      var base = cards[0].offsetLeft;
      stops = [];
      for(var i=0;i<cards.length;i++){
        var left = cards[i].offsetLeft - base;
        if(left <= max + 2) stops.push({card:cards[i], left:left});
        else break;
      }
      if(!stops.length) stops.push({card:cards[0], left:0});

      if(dotWrap){
        dotWrap.innerHTML = '';
        dots = [];
        if(stops.length > 1){
          stops.forEach(function(s,i){
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'kup-cdot';
            b.setAttribute('aria-label', 'Go to ' + (s.card.getAttribute('data-title') || ('item ' + (i+1))));
            b.addEventListener('click', function(){
              rail.scrollTo({left:s.left, behavior:'smooth'});
            });
            dotWrap.appendChild(b);
            dots.push(b);
          });
        }
      }

      // Nothing to scroll: hide the whole control row rather than show a
      // single inert dot between two dead arrows.
      if(ctrl) ctrl.style.display = (max > 4) ? '' : 'none';
      active = -1;
      sync();
    }

    function sync(){
      ticking = false;
      if(!dots.length) return;
      var x = rail.scrollLeft, best = 0, bd = Infinity;
      for(var i=0;i<stops.length;i++){
        var d = Math.abs(stops[i].left - x);
        if(d < bd){ bd = d; best = i; }
      }
      if(best === active) return;
      if(dots[active]) dots[active].classList.remove('is-active');
      active = best;
      if(dots[active]) dots[active].classList.add('is-active');
    }

    function step(dir){
      var w = cards[0].getBoundingClientRect().width;
      rail.scrollBy({left: dir * (w + gap()), behavior:'smooth'});
    }

    if(prev) prev.addEventListener('click', function(){ step(-1); });
    if(next) next.addEventListener('click', function(){ step(1); });

    rail.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }, {passive:true});

    rail.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ e.preventDefault(); step(1); }
      if(e.key === 'ArrowLeft'){ e.preventDefault(); step(-1); }
    });

    var rt = null;
    window.addEventListener('resize', function(){
      if(rt) clearTimeout(rt);
      rt = setTimeout(build, 180);
    }, {passive:true});

    build();
    // Product images load lazily and can change the rail's width after paint.
    window.addEventListener('load', build);
    if(window.ResizeObserver) new ResizeObserver(function(){
      if(rt) clearTimeout(rt);
      rt = setTimeout(build, 180);
    }).observe(rail);
  }

  function boot(){
    var rails = document.querySelectorAll('[data-kup-coffees-rail]');
    for(var i=0;i<rails.length;i++) init(rails[i]);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* KUP Coffees — three-line product titles.

   The card reserves three lines for the title, but a short title only fills
   two of them, leaving a visible hole above the region line. Product titles
   are pipe-separated ("Name | Spec | 250g"), so a title that comes up short
   can be broken at one of its own separators to fill the third line.

   Breaks are tried from the last separator backwards, taking the first one
   that lands on exactly three lines. If no break helps — or a break would
   overflow to four — the original text is restored rather than left worse.

   Line counting uses Range.getClientRects() rather than scrollHeight, because
   the title already carries a three-line min-height: scrollHeight would report
   three lines for a two-line title and the whole thing would no-op.

   Recalculated on resize and after fonts load, since where a title wraps
   depends on both. */
(function(){
  'use strict';

  var TARGET = 3;

  function lineCount(el){
    var range = document.createRange();
    range.selectNodeContents(el);
    var rects = range.getClientRects();
    var seen = {}, n = 0;
    for(var i = 0; i < rects.length; i++){
      if(rects[i].height <= 0) continue;
      var top = Math.round(rects[i].top);
      if(!seen[top]){ seen[top] = 1; n++; }
    }
    return n;
  }

  /* Rebuilt with real text nodes rather than innerHTML — the text is merchant
     content and should never be parsed as markup. */
  function render(el, parts, breakAt){
    el.textContent = '';
    for(var i = 0; i < parts.length; i++){
      if(i === 0){
        el.appendChild(document.createTextNode(parts[i]));
        continue;
      }
      if(i === breakAt) el.appendChild(document.createElement('br'));
      else el.appendChild(document.createTextNode(' '));
      el.appendChild(document.createTextNode('| ' + parts[i]));
    }
  }

  function balance(el){
    var full = el.getAttribute('data-kup-full');
    if(full === null){
      full = el.textContent.replace(/\s+/g, ' ').trim();
      el.setAttribute('data-kup-full', full);
    }

    el.textContent = full;
    if(lineCount(el) >= TARGET) return;

    var raw = full.split('|'), parts = [];
    for(var i = 0; i < raw.length; i++){
      var t = raw[i].trim();
      if(t) parts.push(t);
    }
    if(parts.length < 2) return;

    for(var b = parts.length - 1; b >= 1; b--){
      render(el, parts, b);
      var n = lineCount(el);
      if(n === TARGET) return;
      if(n > TARGET) break;
    }

    el.textContent = full;
  }

  function runBalance(){
    var titles = document.querySelectorAll('.kup-card-title');
    for(var i = 0; i < titles.length; i++) balance(titles[i]);
  }

  var bt = null;
  function scheduleBalance(){
    if(bt) clearTimeout(bt);
    bt = setTimeout(runBalance, 150);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runBalance);
  else runBalance();

  window.addEventListener('load', scheduleBalance);
  window.addEventListener('resize', scheduleBalance, {passive:true});
  document.addEventListener('shopify:section:load', scheduleBalance);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(runBalance);
})();
